import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import { getNameWithFilter } from '../../../../utils/help';
import Act from './Act/Act';
import { ThemeContext } from '../../../App/ThemeContext';
import { NavigationContext as Context } from '../../Context';
import { ReactComponent as Arrow } from '../../../../assets/imgs/svg/arrow.svg';
import commonClasses from '../NavComponents.module.scss';
import classes from './Topic.module.scss';

const Topic = (props) => {
  const { topic, index } = props;
  const context = useContext(Context);
  const { theme } = useContext(ThemeContext);
  const { selected, filter } = context;

  let result = null;

  if (topic.show) {
    result = (
      <div key={index} className={`${classes.Topic} ${selected.topic === index ? classes.open : ''}`}>
        <div
          role="button"
          className={`${commonClasses.Label} ${classes.label} ${theme ? classes[theme] : ''}`}
          onClick={() => context.onTopicClick(index)}
          onKeyDown={(event) => { if (event.key === 'Enter') context.onTopicClick(index); }}
          tabIndex="0"
        >
          <span className={classes.title}>
            { ReactHtmlParser(getNameWithFilter(topic.name, filter)) }
          </span>
          <Arrow className={`${commonClasses.LabelArrow} ${classes.LabelArrow}`} />
        </div>
        <div className={`${commonClasses.dropDownBlock} ${selected.topic === index ? commonClasses.open : ''}`}>
          {topic.children.map((act, i) => <Act key={act.name} act={act} actIndex={i} topicIndex={index} />)}
        </div>
      </div>
    );
  }

  return result;
};

export default React.memo(Topic);

Topic.propTypes = {
  topic: PropTypes.shape({
    name: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
};
